module.exports = __webpack_public_path__ + "img/akqa-london.6d3d14e6.jpg";